module.exports = __webpack_public_path__ + "static/media/coffee-promo-dt-en.39957f41.mp4";